import consumer from "./consumer"

document.addEventListener("DOMContentLoaded", function () {

  const chatForm = document.getElementById("js-chat-form");
  const chatBox = document.querySelector('#js-chat-box');

  if (chatForm) {
    const messageInput = chatForm.querySelector('textarea[name="message[body]"]');
    if (messageInput) {
      messageInput.addEventListener("keydown", function (event) {
        if (event.isComposing || event.key !== "Enter" || event.shiftKey) {
          return;
        }

        if (messageInput.value.trim() === "") {
          return;
        }

        event.preventDefault();
        if (chatForm.requestSubmit) {
          chatForm.requestSubmit();
        } else {
          const submitBtn = chatForm.querySelector("#js-chat-send");
          if (submitBtn) {
            submitBtn.click();
          } else {
            chatForm.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
          }
        }
      });
    }

    chatForm.addEventListener("submit", function (event) {
      event.preventDefault();
      const formData = new FormData(chatForm);

      fetch(chatForm.action, {
        method: "POST",
        body: formData,
        credentials: "same-origin"
      })
        .then(response => {
          if (response.ok) {
            chatForm.reset();
            console.log("Message sent successfully.");

            // Handle new conversation creation
            if (response.status === 201) {
              return response.json().then(data => {
                if (data.conversation_id && chatBox) {
                  console.log("New conversation created:", data.conversation_id);
                  chatBox.dataset.conversationId = data.conversation_id;

                  // Insert the first message immediately
                  if (data.html) {
                    chatBox.insertAdjacentHTML("afterbegin", data.html);
                  }

                  // Subscribe to the new conversation for future messages
                  const cable = consumer || (window.App && window.App.cable);
                  if (cable) {
                    cable.subscriptions.create(
                      { channel: "ChatChannel", conversation_id: data.conversation_id },
                      {
                        received(data) {
                          const you = String(data.sender_id) === String(window.CURRENT_USER_ID);
                          if (you) {
                            chatBox.insertAdjacentHTML("afterbegin", data.html_me);
                          } else {
                            chatBox.insertAdjacentHTML("afterbegin", data.html_other);
                          }
                        }
                      }
                    );
                  }
                }
              });
            }
          } else {
            response.text().then(text => {
              console.error("HTTP error :", response.status, response.statusText, "Answer:", text);
            });
          }
        })
        .catch(error => {
          console.error("network/fetch error:", error);
        });
    });
  }

  if (chatBox) {
    const CURRENT_CONVERSATION_ID = chatBox.dataset.conversationId;
    console.log("chat loaded. ConversationID:", CURRENT_CONVERSATION_ID)
    
    const cable = consumer || (window.App && window.App.cable);
    if (!cable) {
      console.warn("ChatChannel: missing ActionCable consumer; subscription skipped.");
    } else {
      cable.subscriptions.create({channel: "ChatChannel", conversation_id: CURRENT_CONVERSATION_ID},
      {
        received(data) {
          const you = String(data.sender_id) === String(window.CURRENT_USER_ID);
          if (you) {
            chatBox.insertAdjacentHTML("afterbegin", data.html_me);
          } else {
            chatBox.insertAdjacentHTML("afterbegin", data.html_other);
          }
        }
      }
    );
    }
  }
});
